export enum ModulesDescription {
    Alerts = 'Alerts',
    Cases = 'Cases',
    Complaint = 'Complaint'
}